// extracted by mini-css-extract-plugin
export default {"root":"AuthorsCounter__root--2N7xo","item":"AuthorsCounter__item--1kPqK","counter":"AuthorsCounter__counter--3uYsn"};